import CategoryCard from "Pages/category/categoryCard";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getrecentListing } from "store/actions";

const ResentList = () => {
  const dispatch = useDispatch()
  const { loading, recentListings } = useSelector((s) => s?.SellItems)
  const [filter, setFilter] = useState({
    count: 4,
    sortFiled: "created_date",
    sortOrder: 1
  })
  useEffect(() => {
    dispatch(getrecentListing(filter))
  }, [dispatch])
  return (
    <div className=" container-fluid recentList">
      <Container>
        <Row>
          <Col lg={12}>
            <div className="d-flex align-items-baseline justify-content-between">
              <div className="DigitalArtcollection-head">
                <h2>Recent Listing</h2>
              </div>
              {/* <Link className="viewText" to="/art-genres" style={{}}  >View all</Link> */}
            </div>
          </Col>
        </Row>
        <div className="recentLisMain">
          <Row>
            {recentListings.length > 0 ? recentListings.map((item, idx) =>
              <Col lg={3} key={idx}>
                <CategoryCard data={item} />
              </Col>
            ) : <div className="text-center d-grid justify-content-center dataNotFound py-5">
              <img src={"../../images/svg/mpdatanft.svg"} className="mb-4" alt="Create collection" />
              <h3>No Recent Listing Available</h3>
            </div>}
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default ResentList;
